module.exports = __webpack_public_path__ + "img/app.366aeddd.png";